import { slugifyPayload } from '@gaming1/g1-utils';

import { SearchGamesRequest } from './types';

export const slugifySearchPayload = (payload: SearchGamesRequest) =>
  slugifyPayload({ nameFilter: payload.NameFilter });
